export default "__VITE_ASSET__D80FOkfz__"